// extracted by mini-css-extract-plugin
export default {"content":"styles_content__0TU4p","time":"styles_time__DH83Q"};